module.exports = __webpack_public_path__ + "img/thumbnail-lollspace-alpha.6d6daee6.png";